import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBa8Zch9efKXSA48Limjg6Qy3NzQaG8Fyg",
  authDomain: "real-world-wealth.firebaseapp.com",
  projectId: "real-world-wealth",
  storageBucket: "real-world-wealth.firebasestorage.app",
  messagingSenderId: "434975113413",
  appId: "1:434975113413:web:c3816bbff410f05e7070ac"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
